<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20.224" height="17.696" viewBox="0 0 20.224 17.696">
        <path id="Caminho_10450" data-name="Caminho 10450" d="M18.249,33.177a5.4,5.4,0,0,0-7.371.537l-.778.8-.778-.8a5.4,5.4,0,0,0-7.371-.537,5.672,5.672,0,0,0-.391,8.212L9.2,49.28a1.238,1.238,0,0,0,1.789,0l7.643-7.892a5.668,5.668,0,0,0-.387-8.212Z" transform="translate(0.012 -31.967)" fill="#0771c5"/>
    </svg>
</template>
